import { Text, TextProps } from '@chakra-ui/react';

interface IOwnProps extends TextProps {
  children: string;
  isRequired?: boolean;
  fontSize?: string;
}

const TitleSectionMobilePage: React.FC<IOwnProps> = ({ children, isRequired = false, ...rest }) => {
  return (
    <Text
      pr={4}
      pb={1}
      mb={2}
      fontWeight="bold"
      borderBottom="1px solid"
      w="fit-content"
      borderColor="gray.200"
      fontSize="md"
      {...rest}
    >
      {children}
      {isRequired && (
        <Text as="span" ml={1} color="red">
          *
        </Text>
      )}
    </Text>
  );
};

export default TitleSectionMobilePage;
